export enum ModalIDEnum {
  PreloadError = "preload-error",
}
